import { createContext } from 'react';

export const MenuGroupIdContext = createContext<string | undefined>(undefined);
